/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import FlagIcon from "@mui/icons-material/Flag";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import Stack from "@mui/material/Stack";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSnackbar } from "notistack";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import {
  deleteBill,
  getBillList,
  updateBillFlag,
} from "app/redux/slice/billSlice";
import { getVendorList } from "app/redux/slice/vendorSlice";
import { BILL_ADD, billEdit, billView } from "app/routes/constant";
import Span from "@jumbo/shared/Span";
import { LoadingButton } from "@mui/lab";
import { Edit, FlagCircle, WarningAmber } from "@mui/icons-material";
import { resetFlagsApi } from "app/redux/slice/commonSlice";
const BillList = () => {
  const navigate = useNavigate();

  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();

  const billData = useSelector((state) => state?.bill);
  const supplierData = useSelector((state) => state?.vendor);

  // Load saved filters from localStorage
  const getSavedFilters = () => {
    try {
      const saved = localStorage.getItem("bill-filters");
      return saved ? JSON.parse(saved) : {};
    } catch (error) {
      console.error("Error loading saved filters:", error);
      return {};
    }
  };

  // Save filters to localStorage
  const saveFilters = (filters) => {
    try {
      localStorage.setItem("bill-filters", JSON.stringify(filters));
    } catch (error) {
      console.error("Error saving filters:", error);
    }
  };

  const savedFilters = getSavedFilters();

  const [searchText, setSearchText] = useState(savedFilters.searchText || "");
  const [order, setOrder] = useState(savedFilters.order || "desc");
  const [orderBy, setOrderBy] = useState(savedFilters.orderBy || "createdAt");
  const [supplierId, setSupplierId] = useState(savedFilters.supplierId || null);
  const [type, setType] = useState(savedFilters.type || "All");
  const [fromDate, setFromDate] = useState(savedFilters.fromDate || "");
  const [toDate, setToDate] = useState(savedFilters.toDate || "");
  const [paymentStatus, setPaymentStatus] = useState(
    savedFilters.paymentStatus || "All"
  );
  const [flagStatus, setFlagStatus] = useState(
    savedFilters.flagStatus || "All"
  );
  const [showFlag, setShowFlag] = useState(false);

  const [dueStatus, setDueStatus] = useState(savedFilters.dueStatus || "All");
  const [showDeleted, setShowDeleted] = useState(
    savedFilters.showDeleted || false
  );

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "invoice" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    deletePermission: false,
  });

  // Update localStorage whenever filters change
  useEffect(() => {
    const filters = {
      searchText,
      order,
      orderBy,
      supplierId,
      type,
      fromDate,
      toDate,
      paymentStatus,
      flagStatus,
      showDeleted,
      dueStatus,
    };
    saveFilters(filters);
  }, [
    searchText,
    order,
    orderBy,
    supplierId,
    type,
    fromDate,
    toDate,
    paymentStatus,
    flagStatus,
    showDeleted,
    dueStatus,
  ]);

  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        deletePermission: false,
      };
      const rolePermission = permissionData;
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "create-bill") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-bill") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-bill") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    { id: "createFor", label: "Type", sort: true, minWidth: 90 },
    {
      id: "flag",
      label: "Flag",
      sort: false,
      align: "center",
      render: (elm) => {
        const isFlagged = elm?.flag || false;
        return (
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              const newValue = !isFlagged;
              dispatch(
                updateBillFlag({ id: elm?._id, data: { flag: newValue } })
              )
                .unwrap()
                .then((res) => {
                  if (res?.status === 200) {
                    enqueueSnackbar("Flag updated successfully", {
                      variant: "success",
                    });
                    getData();
                  } else {
                    enqueueSnackbar(
                      res?.data?.responseMessage || "Update failed",
                      { variant: "error" }
                    );
                  }
                });
            }}
          >
            {isFlagged ? (
              <FlagIcon color="primary" />
            ) : (
              <EmojiFlagsIcon color="disabled" />
            )}
          </IconButton>
        );
      },
    },
    { id: "poId", label: "PO No", render: (row) => row?.poId?.poNo },
    { id: "billNo", label: "Bill No", sort: true },
    {
      id: "billDate",
      minWidth: 115,
      label: "Date",
      sort: true,
      render: (row) =>
        row?.billDate ? moment(row?.billDate).format("DD-MM-YYYY") : "",
    },
    {
      id: "dueDate",
      minWidth: 115,
      label: "Due Date",
      sort: true,
      render: (row) => moment(row?.dueDate).format("DD-MM-YYYY"),
    },
    {
      id: "vendor",
      label: "Vendor",
      render: (row) => row?.vendorId?.name,
      minWidth: 100,
    },
    {
      id: "totalAmount",
      label: "Amount",
      minWidth: 100,
      isTotal: true,
      format: (value) => value?.toFixed(2),
    },
    {
      id: "paidAmount",
      label: "Paid Amount",
      minWidth: 100,
      isTotal: true,
      format: (value) => value?.toFixed(2),
    },
    {
      id: "pendingAmount",
      label: "Pending Amount",
      minWidth: 100,
      isTotal: true,
      format: (value) => value?.toFixed(2),
    },
    {
      id: "paymentStatus",
      label: "Payment Status",
      align: "center",
      render: (row) =>
        row?.paymentStatus === 2 ? (
          <Span style={{ color: "green" }}>Paid</Span>
        ) : row?.paymentStatus === 1 ? (
          <Span style={{ color: "#d77700" }}>Partial Paid</Span>
        ) : (
          <Span style={{ color: "red" }}>Pending</Span>
        ),
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 140,
      align: "center",
      render: (row) => (
        <>
          {row.createFor === "Other" ? (
            <IconButton
              disabled={!permission.updatePermission}
              onClick={() => {
                navigate(billEdit(row?._id));
              }}
            >
              <Edit />
            </IconButton>
          ) : (
            <IconButton
              disabled={!permission.updatePermission}
              onClick={() => {
                navigate(billView(row?._id));
              }}
            >
              <Edit />
            </IconButton>
          )}
          {/* <Tooltip title="Debit Note">
            <IconButton
              disabled={!permission.updatePermission}
              onClick={() => {
                navigate(debitNote(row?._id));
              }}
            >
              <NoteAltIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Debit Note List">
            <IconButton
              disabled={!permission.updatePermission}
              onClick={() => {
                navigate(debitNoteList(row?._id));
              }}
            >
              <ViewListIcon />
            </IconButton>
          </Tooltip> */}
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const deletedColumns = [
    { id: "createFor", label: "Type", sort: true, minWidth: 90 },
    {
      id: "flag",
      label: "Flag",
      sort: false,
      align: "center",
      render: (elm) => {
        const isFlagged = elm?.flag || false;
        return (
          <IconButton>
            {isFlagged ? (
              <FlagIcon color="primary" />
            ) : (
              <EmojiFlagsIcon color="disabled" />
            )}
          </IconButton>
        );
      },
    },
    { id: "poId", label: "PO No", render: (row) => row?.poId?.poNo },
    { id: "billNo", label: "Bill No", sort: true },
    {
      id: "billDate",
      minWidth: 115,
      label: "Date",
      sort: true,
      render: (row) =>
        row?.billDate ? moment(row?.billDate).format("DD-MM-YYYY") : "",
    },
    {
      id: "dueDate",
      minWidth: 115,
      label: "Due Date",
      sort: true,
      render: (row) => moment(row?.dueDate).format("DD-MM-YYYY"),
    },
    {
      id: "vendor",
      label: "Vendor",
      render: (row) => row?.vendorId?.name,
      minWidth: 100,
    },
    { id: "totalAmount", label: "Amount", minWidth: 100 },
  ];

  const DeleteInvoice = () => {
    closeDelete();
    dispatch(deleteBill(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const onConfirmFlagReset = () => {
    setShowFlag(false);
    dispatch(resetFlagsApi("Bill"))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      ...(supplierId && { vendorId: supplierId?._id }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
      ...(type !== "All" && {
        createFor: type,
      }),
      ...(paymentStatus !== "All" && {
        paymentStatus,
      }),
      ...(flagStatus !== "All" && { flag: flagStatus === "true" }),
      ...(dueStatus !== "All" && { status: dueStatus }),
      ...(showDeleted && { deletedAt: true }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getBillList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSearchText("");
    setSupplierId(null);
    setType("All");
    setFromDate("");
    setToDate("");
    setPaymentStatus("All");
    setFlagStatus("All");
    setShowDeleted(false);
    setOrder("desc");
    setOrderBy("createdAt");
    handleChangePage(0, 0);
  };

  useEffect(() => {
    getPermission();
    dispatch(getVendorList({ sort: 1, field: "name" }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy, showDeleted]);

  return (
    <>
      {billData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <TextField
                      type="date"
                      label={"From Date"}
                      name="fromDate"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                      size="small"
                      value={fromDate}
                      onChange={(evt) => setFromDate(evt.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      type="date"
                      label={"To Date"}
                      name="toDate"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                      size="small"
                      value={toDate}
                      onChange={(evt) => setToDate(evt.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2.5}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Vendor"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Flag</InputLabel>
                      <Select
                        value={flagStatus}
                        label="Flag"
                        size="small"
                        onChange={(e) => setFlagStatus(e.target.value)}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="true">Flagged</MenuItem>
                        <MenuItem value="false">Unflagged</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Type</InputLabel>
                      <Select
                        name="type"
                        id="type"
                        value={type}
                        label="type"
                        size="small"
                        onChange={(e) => setType(e.target.value)}
                      >
                        <MenuItem value="All">All</MenuItem>
                        {[
                          "Fabric",
                          "Stitch",
                          "Modeling",
                          "ReadyMade",
                          "Dyer",
                        ].map((val) => {
                          return (
                            <MenuItem key={val} value={val}>
                              {val}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Payment Status</InputLabel>
                      <Select
                        name="isInvoiceCreated"
                        id="isInvoiceCreated"
                        value={paymentStatus}
                        label="Payment Status"
                        size="small"
                        onChange={(e) => setPaymentStatus(e.target.value)}
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        <MenuItem value={"0"}>Pending</MenuItem>
                        <MenuItem value={"1"}>Partial Paid</MenuItem>
                        <MenuItem value={"2"}>Paid</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={1.75}>
                    <FormControl fullWidth>
                      <InputLabel>Due </InputLabel>
                      <Select
                        value={dueStatus}
                        label="Due"
                        size="small"
                        onChange={(e) => setDueStatus(e.target.value)}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="overdue">Overdue</MenuItem>
                        <MenuItem value="due">Due</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={1.75}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Bill List
                </Typography>
                <>
                  <Typography variant={"h2"} mb={0}>
                    {`Pending Amount = ${billData?.totalPendingAmount}`}
                  </Typography>

                  <Div sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      Show Deleted
                    </Typography>
                    <Switch
                      checked={showDeleted}
                      onChange={(e) => setShowDeleted(e.target.checked)}
                      color="primary"
                    />
                    {permission.updatePermission && (
                      <Tooltip title="Reset All Flags">
                        <IconButton onClick={() => setShowFlag(true)}>
                          <FlagCircle color="primary" sx={{ fontSize: 30 }} />
                        </IconButton>
                      </Tooltip>
                    )}
                    {permission.createPermission && (
                      <LoadingButton
                        onClick={() => {
                          navigate(BILL_ADD);
                        }}
                        sx={{
                          mt: { xs: 1, md: 0 },
                        }}
                        type="submit"
                        variant="contained"
                      >
                        Add Bill
                      </LoadingButton>
                    )}
                  </Div>
                </>
              </Stack>
              <Table
                columns={showDeleted ? deletedColumns : columns}
                rows={billData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={billData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
                showTotalInFooter={true}
              />
            </CardContent>
          </Card>
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the Bill?"
            onConfirm={DeleteInvoice}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
          <Dialog
            open={showFlag}
            onClose={() => setShowFlag(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                pb: 0,
              }}
            >
              <WarningAmber sx={{ color: "error.main", fontSize: 28 }} />
              <Typography
                variant="h6"
                component="span"
                sx={{ fontWeight: 600, color: "text.primary" }}
              >
                Reset All Flags?
              </Typography>
            </DialogTitle>

            <DialogContent sx={{ pt: 1 }}>
              <Typography variant="body1">
                This will reset all flags on this page. Do you want to continue?
              </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
              <Button
                onClick={() => setShowFlag(false)}
                variant="outlined"
                color="inherit"
              >
                Cancel
              </Button>
              <Button
                onClick={onConfirmFlagReset}
                variant="contained"
                color="error"
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default BillList;
